<template>
  <div class="app-container">
    <el-card class="card">
      <el-row :gutter="24">
        <el-col :span="6">
          <el-select
            style="width: 100%;"
            :filterable="true"
            remote
            :remote-method="customersFilter"
            :loading="customerRemoteLoading"
            :default-first-option="true"
            v-model="condition.cid"
            placeholder="渠道平台"
            clearable
            v-blurremovereadonly
          >
            <el-option
              v-for="(item, index) in customers"
              :key="index"
              :label="item.name + '(' + item.cid + ')'"
              :value="item.cid"
            >
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="6">
          <el-date-picker
            style="width: 100%"
            v-model="condition.logtime"
            type="datetimerange"
            align="center"
            start-placeholder="起始时间"
            end-placeholder="起止时间"
            :default-time="['00:00:00', '23:59:59']"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-col>

        <el-col :span="6" style="margin-top: 5px;padding-left: 30px">
          <el-radio-group v-model="condition.durationGroup">
            <el-radio :label="1">小时</el-radio>
            <el-radio :label="2">天</el-radio>
            <el-radio :label="3">周</el-radio>
          </el-radio-group>
        </el-col>

        <el-col :span="6">
          <el-button type="primary" @click="search()" icon="el-icon-search">查询</el-button>
          <el-button @click="toResetCondition()" icon="el-icon-refresh">重置</el-button>
          <el-button v-if="hasExportPrivilege" type="warning" @click="exportData()" icon="el-icon-download"
            >导出</el-button
          >
        </el-col>
      </el-row>
    </el-card>

    <el-card class="card_2">
      <el-table
        :data="tableData"
        border
        :row-class-name="getRowClassName"
        v-loading="fullscreenLoading"
        element-loading-text="努力加载中..."
        :header-cell-style="{ background: '#F5F7FA', color: '#000000' }"
      >
        <el-table-column prop="cid" label="cid" align="center"></el-table-column>
        <el-table-column prop="durationGroup" label="分组" align="center" v-if="this.groupStatus"></el-table-column>
        <el-table-column prop="searchTotalCount" sortable label="总数" align="center"></el-table-column>
        <el-table-column prop="dataTotalCount" sortable label="出数" align="center"></el-table-column>
        <el-table-column prop="noDataTotalCount" sortable label="未出数" align="center"></el-table-column>
        <el-table-column prop="dataRate" sortable label="出数率" align="center">
          <template slot-scope="scope">
            {{ parseFloat(scope.row.dataRate != 0 ? scope.row.dataRate * 100 : 0).toFixed(2) + '%' }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="dataTotalElapsed" label="出数耗时" align="center"></el-table-column> -->
        <el-table-column prop="dataAvgElapsed" label="出数平均耗时(ms)" align="center"></el-table-column>
        <!-- <el-table-column prop="noDataTotalElapsed" label="未出数耗时" align="center"></el-table-column> -->
        <!--        <el-table-column prop="totalElapsed" label="查询总耗时" align="center"></el-table-column>-->
      </el-table>
      <!-- 分页功能 -->
      <!--      <el-pagination-->
      <!--        style="margin-top: 20px"-->
      <!--        @size-change="hadleSizeChange"-->
      <!--        @current-change="handleCerrentChange"-->
      <!--        layout="total, sizes, prev, pager, next, jumper"-->
      <!--        :current-page="currpage"-->
      <!--        :total="total"-->
      <!--        :page-sizes="[4, 10, 15, 20]"-->
      <!--        :page-size="pagesize"-->
      <!--        background-->
      <!--      >-->
      <!--      </el-pagination>-->
    </el-card>

    <data-export v-if="hasExportPrivilege" ref="dataExport" :exportType="exportType" :condition="condition" />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import * as commonApi from '@/api/common'
import { tokenVerify } from '@/util/common'
import * as channelWithDataApi from '@/api/channelwithdata'
import DataExport from '@/components/DataExport'
import userManager from '@/sso/user-manager'
import permissionCodes from '@/sso/permission-code'

export default {
  name: 'ChannelWithData',
  components: {
    DataExport,
  },
  data() {
    return {
      hasExportPrivilege: this.getExportPrivilege(),
      exportVisible: false,
      exportType: 'ChannelWithData',
      groupStatus: false,
      tableData: [],
      pagesize: 10,
      currpage: 1,
      total: null,
      customers: [],
      oriCustomers: [],
      customerRemoteLoading: false,
      condition: {
        cid: null,
        durationGroup: 2,
        logtime: [
          dayjs()
            .hour(0)
            .minute(0)
            .second(0)
            .format('YYYY-MM-DD HH:mm:ss'),
          dayjs()
            .hour(23)
            .minute(59)
            .second(59)
            .format('YYYY-MM-DD HH:mm:ss'),
        ],
      },
      fullscreenLoading: false,
    }
  },
  created() {
    this.initCustomer()
    this.getList(this.currpage, this.pagesize)
  },

  methods: {
    getExportPrivilege() {
      return userManager.checkPermission([permissionCodes.ChannelWithData])
    },
    async initCustomer() {
      let customerResponse = await this.searchCustomer()
      this.customers = customerResponse.data.data
      this.oriCustomers = customerResponse.data.data
    },
    async customersFilter(name) {
      this.customerRemoteLoading = true
      if (name) {
        let customerResponse = await this.searchCustomer(name)
        this.customers = customerResponse.data.data
      } else {
        this.customers = this.oriCustomers
      }
      this.customerRemoteLoading = false
    },
    async searchCustomer(name) {
      const customerResponse = await commonApi.getCustomerList(name)
      await tokenVerify(this, customerResponse)
      return customerResponse
    },
    async search() {
      this.currpage = 1
      await this.getList(this.currpage, this.pagesize)
    },
    async getList(n, m) {
      this.fullscreenLoading = true
      const response = await channelWithDataApi.list(this.condition, n, m)
      if (response.status === 200 && response.data.status === 0) {
        this.tableData = response.data.data
        this.total = response.data.total
        if (response.data.data) {
          let checkGroupStatus = false
          for (let i = 0; i < response.data.data.length; i++) {
            let item = response.data.data[i]
            if (item.durationGroup && item.durationGroup !== '') {
              checkGroupStatus = true
              break
            }
          }
          this.groupStatus = checkGroupStatus
        }
      } else {
        this.$message.error(response.data.message)
      }
      this.fullscreenLoading = false
    },
    toResetCondition() {
      this.condition = {
        cid: null,
        durationGroup: null,
        logtime: [],
      }
    },
    getRowClassName({ row }) {
      if (row.status === 0) {
        return 'invalid-row'
      }
    },
    hadleSizeChange(val) {
      this.pagesize = val
      this.getList(this.currpage, val)
    },
    handleCerrentChange(val) {
      this.currpage = val
      this.getList(val, this.pagesize)
    },

    exportData() {
      this.$refs.dataExport.exportVisible('/export/channel/withData', '渠道查询出数率数据导出')
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  width: 99%;
  min-width: 720px;
  background: #ffffff;
  box-shadow: 0 0 6px 0 rgba(11, 37, 64, 0.1);
  border-radius: 4px;
  margin: 10px 10px 12px 10px;
}

.card_2 {
  width: 99%;
  min-width: 720px;
  margin: 0 10px 12px 10px;
  background: #ffffff;
  box-shadow: 0 0 6px 0 rgba(11, 37, 64, 0.1);
  border-radius: 4px;
}

/deep/ .el-table .invalid-row {
  background: rgb(247, 234, 234);
}

.app-container {
  min-width: 1080px;
}

.el-date-editor--datetimerange.el-input__inner {
  width: auto;
}

.table_ {
  margin-top: 20px;
}

::v-deep {
  .el-date-editor--datetimerange.el-input__inner {
    width: 100%;
  }
}
</style>
